export const FlagCategoryEnum = {
  CopyrightInfringement: 'COPYRIGHT_INFRINGEMENT',
  HateSpeech: 'HATE_SPEECH',
  Pornography: 'PORNOGRAPHY',
  Spam: 'SPAM',
  Other: 'OTHER'
} as const;

export type FlagCategoryEnum =
  (typeof FlagCategoryEnum)[keyof typeof FlagCategoryEnum];
